import { SelectOption } from 'global';
import { RatePresentationType, ContactType, BrandingType } from '../types/form';

export const ratePresentationOptions: SelectOption<RatePresentationType>[] = [
  { label: 'None', value: RatePresentationType.NONE },
  { label: 'Annualized', value: RatePresentationType.ANNUALIZED },
  { label: 'APR', value: RatePresentationType.APR },
];

export const contactTypeOptions: SelectOption<ContactType>[] = [
  { label: 'Both', value: ContactType.BOTH },
  { label: 'Dealer', value: ContactType.DEALER },
  { label: 'Lender', value: ContactType.LENDER },
];

export const brandingTypeOptions: SelectOption<BrandingType>[] = [
  { label: 'Co-Branded', value: BrandingType.COBRANDED },
  { label: 'Dealer', value: BrandingType.DEALER },
  { label: 'Lender', value: BrandingType.LENDER },
];
